module.exports = __webpack_public_path__ + "media/images/filter-132ac48482c6311f80a929476895d071.png";